const font = {
  header: '40px',
  secondaryHeaderM: '20px',
  secondaryHeaderS: '18px',
  textS: '12px',
  textM: '14px',
  textG: '16px',
  letterSpacing: '1px',
  weight500: '500',
  weight600: '600'
};

export default font;
